module.exports = __webpack_public_path__ + "static/media/vf_mbag_core.e1e8a006.svg";